module.exports = __webpack_public_path__ + "img/mail.bfe7e69e.svg";